// extracted by mini-css-extract-plugin
module.exports = {"entirePageBackground":"SplashPage_entirePageBackground__F6AZe","splashPageBackground":"SplashPage_splashPageBackground__qISOQ"};